import {NavLink} from "react-router-dom";
import {Button, ButtonGroup, Grid} from "@mui/material";
import React, {useState} from "react";

function Subnavigation({items, defaultActive}) {
    const [active, setActive] = useState(defaultActive)

    const activate = (isActive, path, activeStyle, nonActiveStyle) => {

        if (isActive) {
            setActive(path)
            return activeStyle
        }
        return nonActiveStyle
    }

    return (<Grid item size={{lg: 8}} sx={{mb: 2}}>
        <ButtonGroup variant={'text'} color={'info'} sx={{flexWrap: 'wrap'}}>
            {items && items.map(item => {
                if (item.disabled) {
                    return null;
                }
                return (<NavLink to={item.to} style={(activeNav) => {
                    activate(activeNav.isActive, item.to);
                    document.activeElement.blur();
                }} key={item.to} target={item.target !== undefined ? item.target : '_self'}>
                <Button color={active === item.to ? item.color : "info"} variant={active === item.to ? 'contained' : 'outlined'}>{item.name}</Button>
            </NavLink>)
            })}
        </ButtonGroup>
    </Grid>);
}
export default Subnavigation;